import styled from 'styled-components';
import { FlexColumn } from '../../../styled/common';
import { Typography } from '../../ui/Typography';
import { CardGridStyled } from '../../../styled/cardGrid.styled';

export const EmptyBookmarks = styled(FlexColumn)`
  align-items: center;
  margin: 20px 0 80px;
  flex: auto;

  @media (max-width: ${({ theme }) => theme.tabletBreakpoint}) {
    margin-top: 8vh;
  }
`;

export const NoResultText = styled(Typography).attrs({ tag: 'body_2' })`
  margin: 20px 10px 10px;
  text-align: center;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const BookmarkList = styled(CardGridStyled)`
  margin: 10px 0 80px;

  @media (max-width: ${({ theme }) => theme.tabletBreakpoint}) {
    margin: 15px 0;
  }
`;
